var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-badge',{class:`font-size-12 status--${_vm.filterStatus}`},[_c('span',[_vm._v(_vm._s(_vm.status))])])
}
var staticRenderFns = []

export { render, staticRenderFns }